// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"276":"5b63c16e","621":"29b6768e","845":"469935c1","913":"e47ea7b7"}[chunkId] + ".chunk.js";
};